import { NavLink } from "react-router-dom";
import { FiUsers, FiLogOut } from "react-icons/fi";

export default function ParentSidebar({ onLogout }) {
  return (
    <aside className="hidden md:flex flex-col w-64 bg-card border-r border-border min-h-screen p-4 shadow-sm">
      <div className="mb-8">
        <div className="font-bold text-xl text-primary mb-2">Phụ huynh</div>
      </div>
      <nav className="flex flex-col gap-1">
        <NavLink
          to="/parent/children"
          className={({ isActive }) =>
            `flex items-center gap-2 px-3 py-2 rounded hover:bg-primary/10 transition ${
              isActive ? "bg-primary/10 text-primary font-semibold" : "text-text2"
            }`
          }
        >
          <FiUsers /> Quản lý con
        </NavLink>
        {/* Thêm các menu khác cho phụ huynh ở đây nếu cần */}
      </nav>
      <div className="mt-auto">
        <button
          onClick={onLogout}
          className="flex items-center gap-2 w-full text-left px-3 py-2 mt-6 rounded hover:bg-error/10 text-error"
        >
          <FiLogOut /> Đăng xuất
        </button>
      </div>
    </aside>
  );
}
